<vn-dynamic-layout-slot slot="inner-navigation" />
<div id="main-view"><router-outlet (activate)="setMainVisible()" /></div>
<ms-content-box />
<vn-dynamic-layout-slot slot="inner-footer" />
